import { render, staticRenderFns } from "./Remitos-de-compra.vue?vue&type=template&id=35abc163&scoped=true"
import script from "./Remitos-de-compra.vue?vue&type=script&lang=js"
export * from "./Remitos-de-compra.vue?vue&type=script&lang=js"
import style0 from "./Remitos-de-compra.vue?vue&type=style&index=0&id=35abc163&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35abc163",
  null
  
)

export default component.exports